var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewModuleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "02.-Icons\\uD83C\\uDF88",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-120.000000, -552.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Basic-/-Line-/-View-/-Module",
    transform: "translate(120.000000, 552.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,11 L11,11 L11,5 L6,5 L6,11 L6,11 Z M6,19 L11,19 L11,13 L6,13 L6,19 L6,19 Z M13,19 L18,19 L18,13 L13,13 L13,19 L13,19 Z M13,11 L18,11 L18,5 L13,5 L13,11 L13,11 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewModuleIcon);
export default __webpack_public_path__ + "static/media/ViewModuleIcon.a318800325677d15a1b176ce1f97cb26.svg";
export { ForwardRef as ReactComponent };